var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    viewBox: "0 0 50 39.409",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-checkmark",
    d: "M541.361,169.493a5.167,5.167,0,0,1-1.886-.356l-1.064-.421-14.462-15.437,7.44-6.971,9.96,10.631,25.159-26.856,7.441,6.971-28.8,30.738A5.11,5.11,0,0,1,541.361,169.493Z",
    transform: "translate(-523.948 -130.084)",
    fill: "#0c7b0f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default __webpack_public_path__ + "static/media/icon-checkmark.b4a9cef16f7e095576bb402394ba16ef.svg";
export { ForwardRef as ReactComponent };